<template>
    <table class="table table-sm ">
        <tbody>
        <tr>
            <th>{{ $t("surgery.efficiencyTable.excelent") }}</th>
            <td>
                <ul>
                    <li v-for="(line, index) in $t('surgery.efficiencyTable.excelentBody')" :key="index">
                        {{ line }}
                    </li>
                </ul>
            </td>
        </tr>
        <tr>
            <th>{{ $t("surgery.efficiencyTable.good") }}</th>
            <td>
                <ul>
                    <li v-for="(line, index) in $t('surgery.efficiencyTable.goodBody')" :key="index">
                        {{ line }}
                    </li>
                </ul>
            </td>
        </tr>
        <tr>
            <th>{{ $t("surgery.efficiencyTable.moderate") }}</th>
            <td>
                <ul>
                    <li v-for="(line, index) in $t('surgery.efficiencyTable.moderateBody')" :key="index">
                        {{ line }}
                    </li>
                </ul>
            </td>
        </tr>
        <tr>
            <th>{{ $t("surgery.efficiencyTable.poor") }}</th>
            <td>
                <ul>
                    <li v-for="(line, index) in $t('surgery.efficiencyTable.moderateBody')" :key="index">
                        {{ line }}
                    </li>
                </ul>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "EfficiencyTable",
    };
</script>

<style scoped>

</style>